import React from "react";
import CommonTable from "../Table/CommonTable";
import moment from "moment";

/**
 * VoC分析作成履歴 削除項目ビュー
 * state.selectedData をテーブル表示
 */
export const ViewDeleteVocHistoryList = ({ state, langText }) => {
  const columns = [
    {
      Header: langText.Body.CreatedDateTime,
      accessor: 'createdAt',
      Cell: ({ row }) => {
        const v = row.original.createdAt;
        try { return v ? moment(v).format('YYYY/MM/DD HH:mm:ss') : ''; } catch (_) { return ''; }
      }
    },
    {
      Header: langText.Body.Memo,
      accessor: 'memo',
    },
  ];

  return (
    <CommonTable
      className="none-overflow"
      showPagination={true}
      defaultPageSize={10}
      columns={columns}
      data={Array.isArray(state.selectedData) ? state.selectedData : []}
      langText={langText && langText.Table}
    />
  );
};


